const PARTICLE_COLORS = [
  '#FF0000', // Red
  '#00FF00', // Green
  '#0000FF', // Blue
  '#FFFF00', // Yellow
  '#FF00FF', // Magenta
  '#00FFFF', // Cyan
  '#FF8800', // Orange
  '#FF0088', // Pink
];

export class Particle {
  constructor(x, y, color) {
    this.x = x;
    this.y = y;
    this.color = color === 'random' ? PARTICLE_COLORS[Math.floor(Math.random() * PARTICLE_COLORS.length)] : color;
    this.size = Math.random() * 8 + 4;
    this.speedX = (Math.random() - 0.5) * 15;
    this.speedY = (Math.random() - 0.5) * 15;
    this.gravity = 0.5;
    this.life = 1;
    this.decay = 0.02;
  }

  update() {
    this.speedY += this.gravity;
    this.x += this.speedX;
    this.y += this.speedY;
    this.life -= this.decay;
  }

  draw(ctx) {
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fillStyle = `${this.color}${Math.floor(this.life * 255).toString(16).padStart(2, '0')}`;
    ctx.fill();
  }
}